<template>
  <iframe
    :src="linkURL"
    style="border: none;
    position: fixed;
    margin-top: 50px;
	top: 50%;
	left: 50%;
	min-width: 100%;
	min-height: 100%;
	width: auto;
	height: auto;
	-webkit-transform: translateX(-50%) translateY(-50%);
	transform: translateX(-50%) translateY(-50%);
	background-size: cover"/>
</template>
<style scoped>
.login-text div{
  -webkit-filter: blur(0px);
  -moz-filter: blur(0px);
  -o-filter: blur(0px);
  -ms-filter: blur(13px);
  filter: blur(0px);

  -webkit-backdrop-filter: blur(2px); /* Safari 9+ */
  backdrop-filter: blur(2px); /* Chrome and Opera */

  overflow: auto;
}
</style>
<script>
import { mapState } from 'vuex'

export default{
  data () {
    return {
      linkURLEN: 'https://docs.google.com/forms/d/e/1FAIpQLSc6jUKgZgbWbkWmhm_rgFSprU17HqF6-ddqtvcRUn-8k7tdSA/viewform',

      linkURLPT: 'https://docs.google.com/forms/d/e/1FAIpQLScPCnSe2RYN9HvhtDlyOUW2QogFhz7NnFatkCkXiN4GlNSx6g/viewform',

      linkURL: this.idioma === 0 ? this.linkURLPT : this.linkURLEN
    }
  },
  computed: {
    ...mapState('app', ['idioma', 'strings', 'empresa', 'acesso'])
  },
  mounted () {
    this.linkURL = this.idioma === 0 ? this.linkURLPT : this.linkURLEN
  }
}

</script>
